import { Country } from '../model/country.model';

// (AD-228-05) 2 used countries based on current 16 orders in the System
// https://spotmarkt.meinvme.de/api/country
export const countries: Country[] = [
  {
    "id": "0194f5c32039721b90e6994669b91e62",
    "name": "Switzerland",
    "nameGerman": "Schweiz",
    "iso": "CH",
    "position": 10,
    "iso3": "CHE",
    "defaultPostalCodePattern": "[1-9]\\d{3}",
  },
  {
    "id": "0194f5c3188a73b7b1d2e7a141557e50",
    "name": "Germany",
    "nameGerman": "Deutschland",
    "iso": "DE",
    "position": 1,
    "iso3": "DEU",
    "vatIdPattern": "DE\\d{9}",
    "defaultPostalCodePattern": "\\d{5}",
  },
  {
    "id": "0194f5c32250737f93c417a888b3474f",
    "name": "Denmark",
    "nameGerman": "Dänemark",
    "iso": "DK",
    "position": 10,
    "iso3": "DNK",
    "vatIdPattern": "DK\\d{8}",
    "defaultPostalCodePattern": "\\d{4}",
  },
  {
    "id": "0194f5c321e9717284202028375ae1da",
    "name": "Poland",
    "nameGerman": "Polen",
    "iso": "PL",
    "position": 10,
    "iso3": "POL",
    "vatIdPattern": "PL\\d{10}",
    "defaultPostalCodePattern": "\\d{2}-\\d{3}",
  },
  {
    "id": "0194f5c3220872818441eebe20a13913",
    "name": "Czech Republic",
    "nameGerman": "Tschechien, Tschechische Republik",
    "iso": "CZ",
    "position": 10,
    "iso3": "CZE",
    "vatIdPattern": "CZ\\d{8,10}",
    "defaultPostalCodePattern": "\\d{3} ?\\d{2}",
  },
  {
    "id": "0194f5c3201a7133a68318075fe90aca",
    "name": "Austria",
    "nameGerman": "Österreich",
    "iso": "AT",
    "position": 10,
    "iso3": "AUT",
    "vatIdPattern": "ATU\\d{8}",
    "defaultPostalCodePattern": "\\d{4}",
  },
  {
    "id": "0194f5c3226173fdb06d8cc940c66e96",
    "name": "France",
    "nameGerman": "Frankreich",
    "iso": "FR",
    "position": 10,
    "iso3": "FRA",
    "vatIdPattern": "FR[A-HJ-NP-Z0-9]{2}\\d{9}",
    "defaultPostalCodePattern": "\\d{1}(?:A|B|\\d{1}) ?\\d{3}",
  },
  {
    "id": "0194f5c31ff37222b1b7bba4d66ff85d",
    "name": "Luxembourg",
    "nameGerman": "Luxemburg",
    "iso": "LU",
    "position": 10,
    "iso3": "LUX",
    "vatIdPattern": "LU\\d{8}",
    "defaultPostalCodePattern": "\\d{4}",
  },
  {
    "id": "0194f5c32242719fa195439ca95ddddc",
    "name": "Belgium",
    "nameGerman": "Belgien",
    "iso": "BE",
    "position": 10,
    "iso3": "BEL",
    "vatIdPattern": "BE(0|1)\\d{9}",
    "defaultPostalCodePattern": "\\d{4}",
  },
  {
    "id": "0194f5c320097185943a2fc0f3b22caf",
    "name": "Netherlands",
    "nameGerman": "Niederlanden",
    "iso": "NL",
    "position": 10,
    "iso3": "NLD",
    "vatIdPattern": "NL\\d{9}B\\d{2}",
    "defaultPostalCodePattern": "[1-9]{1}\\d{3}([ ]?[A-Z]{2})",
  },
  {
    "id": "0194f5c31fd97042bde013d00454be0a",
    "name": "Italy",
    "nameGerman": "Italien",
    "iso": "IT",
    "position": 10,
    "iso3": "ITA",
    "vatIdPattern": "IT\\d{11}",
    "defaultPostalCodePattern": "\\d{5}",
  },
  {
    "id": "0194f5c35c36700d94030c050551bedc",
    "name": "Bulgaria",
    "nameGerman": "Bulgarien",
    "iso": "BG",
    "position": 10,
    "iso3": "BGR",
    "vatIdPattern": "BG\\d{9,10}",
    "defaultPostalCodePattern": "\\d{4}"
  },
  {
    "id": "0194f5c35c7b7119b5d82e1cfa3cd16e",
    "name": "Slovenia",
    "nameGerman": "Slowenien",
    "iso": "SI",
    "position": 10,
    "iso3": "SVN",
    "vatIdPattern": "SI\\d{8}",
    "defaultPostalCodePattern": "\\d{4}",
  }
];

/**
* Find country by iso, iso3 or partial name match.
* @param {string} query - ISO code or partial country name to search for.
* @returns {object|null} - Found country object or null.
*/
export function findCountry(query: string): Country | null {
  if (!query) return null;

  const search = query.trim().toLowerCase();

  let country = countries.find(c => c.iso && c.iso.toLowerCase() === search);
  if (country) return country;

  country = countries.find(c => c.iso3 && c.iso3.toLowerCase() === search);
  if (country) return country;

  country = countries.find(c => c.name && c.name.toLowerCase().includes(search));
  if (country) return country;

  // if not found `Partial match` for English country name, try to found by part of German country name
  country = countries.find(c => c.nameGerman && c.nameGerman.toLowerCase().includes(search));
  if (country) return country;

  return null;
}

export const CountryUtils = {
  countries,
  findCountry,
};